import React, { useState } from "react";
import "./login.css";
import loginIAC from "../../assets/loginIAC.png";
import Login_leftLogo from "../../assets/Login_leftLogo.png";
import Login_rightLogo from "../../assets/Login_rightLogo.png";
import SignIn from "../../components/Common/SignIn";
import { Divider } from "@mui/material";
import ForgetPassword from "../../components/Common/ForgetPassword";

const Login = () => {
  const [isLoginView, setIsLoginView] = useState(true);
  return (
    <div className="login">
      <div
        style={{
          width: "55%",
          height: "60%",
          minWidth: "500px",
          backgroundColor: "#fff",
          display: "flex",
          boxShadow: "0px 0px 12px #0000003D",
          borderRadius: "5px",
        }}
      >
        <div style={{ flex: 2, display: "flex", flexDirection: "column" }}>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "88%",
              paddingTop: "6%",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "225px",
                  height: "60px",
                  padding: "10px 0px",
                  borderBottom: "1px solid #E4E4E4",
                }}
              >
                <img src={loginIAC} alt="logo" width={"100%"} height={"100%"} />
              </div>
              <p
                style={{
                  color: "#5F5F5F",
                  fontSize: "23px",
                  fontWeight: 500,
                  marginTop: "10px",
                }}
              >
                Scrap Prediction
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "0px 20px",
              // marginBottom: "10px",
            }}
          >
            <div style={{ display: "flex", gap: "10px" }}>
              <img
                src={Login_leftLogo}
                alt="logo"
                width={"80px"}
                height={"25px"}
              />
              <Divider
                sx={{ borderRightWidth: "2.5px", backgroundColor: "#E4E4E4" }}
                orientation="vertical"
                flexItem
              />
              <p
                style={{
                  color: "#5F5F5F",
                  fontSize: "12px",
                  marginTop: "0.5rem",
                  fontWeight: 600,
                }}
              >
                an algo8.ai product
              </p>
            </div>
            <img
              src={Login_rightLogo}
              alt="logo"
              width={"125px"}
              height={"25px"}
            />
          </div>
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderLeft: "1px solid #E4E4E4",
            padding: "20px",
          }}
        >
          {isLoginView ? (
            <SignIn isLoginView={isLoginView} setIsLoginView={setIsLoginView} />
          ) : (
            <ForgetPassword
              isLoginView={isLoginView}
              setIsLoginView={setIsLoginView}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
